import "../styles.scss";

import ReactDOM from "react-dom";
import JoditEditor from "jodit-react";
import { FlagIcon } from "react-flag-kit";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { useState, useEffect, useRef } from "react";

import {
  getDisclosureAffiliate,
  putDisclosureAffiliate,
  postDisclosureAffiliate,
  deleteDisclosureAffiliate,
} from "../../../../store/middleware";
import { SCButtonAddInput } from "../../../../components/Buttons/styles";

const config = {
  readonly: false,
  height: 600,
  nableDragAndDropFileToEditor: true,
  uploader: {
    insertImageAsBase64URI: true,
  },
};

function Disclosure() {
  const editorEN = useRef(null);
  const editorES = useRef(null);
  const editorPT = useRef(null);
  const editorFR = useRef(null);
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const [title, setTitle] = useState("");
  const [order, setOrder] = useState("");
  const [idEN, setIdEN] = useState(true);
  const [idES, setIdES] = useState(true);
  const [idPT, setIdPT] = useState(true);
  const [idFR, setIdFR] = useState(true);
  const [allMenu, setAllMenu] = useState([]);
  const [status, setStatus] = useState(true);
  const [nameMenuEN, setNameMenuEN] = useState("");
  const [nameMenuES, setNameMenuES] = useState("");
  const [nameMenuPT, setNameMenuPT] = useState("");
  const [nameMenuFR, setNameMenuFR] = useState("");
  const [detailDisclosure, setDetailDisclosure] = useState(false);
  const [disclosureContentEN, setDisclosureContentEN] = useState("<p></p>");
  const [disclosureContentES, setDisclosureContentES] = useState("<p></p>");
  const [disclosureContentPT, setDisclosureContentPT] = useState("<p></p>");
  const [disclosureContentFR, setDisclosureContentFR] = useState("<p></p>");

  const getData = () => {
    dispatch(getDisclosureAffiliate("", true)).then((res) => setAllMenu(res));
  };

  const handleSaveDetail = () => {
    try {
      const id = [idEN, idES, idPT, idFR];
      const language = ["EN", "ES", "PT", "FR"];
      const menu = [nameMenuEN, nameMenuES, nameMenuPT, nameMenuFR];
      const content = [disclosureContentEN, disclosureContentES, disclosureContentPT, disclosureContentFR];

      let body = {};

      for (let i = 0; i < 4; i++) {
        body = {
          title,
          order,
          menu: menu[i],
          active: status,
          content: content[i],
          language: language[i],
          textType: "AFFILIATEDIVULGATION",
        };

        if (id[i]) {
          let data = { ...body, id: id[i] };
          dispatch(putDisclosureAffiliate(data));
        } else {
          dispatch(postDisclosureAffiliate(body));
        }
      }
    } catch (e) {
      console.log(e);
    }

    setTimeout(() => {
      setDetailDisclosure(false);
    }, 1000);
  };

  const resetState = () => {
    setIdEN("");
    setIdES("");
    setIdPT("");
    setIdFR("");
    setTitle("");
    setOrder("");
    setStatus(true);
    setNameMenuEN("");
    setNameMenuES("");
    setNameMenuPT("");
    setNameMenuFR("");
    setDisclosureContentEN("");
    setDisclosureContentES("");
    setDisclosureContentPT("");
    setDisclosureContentFR("");
  };

  const handleOpenDetail = async (item, type) => {
    if (type === "add") {
      resetState();
      setDetailDisclosure(true);
    } else {
      await dispatch(getDisclosureAffiliate("", false, item.title)).then((res) => {
        if (res.length > 0) {
          res.map((item) => {
            setTitle(item.title);
            setOrder(item.order);
            setStatus(item.active);

            if (item.language === "EN") {
              setIdEN(item.id);
              setNameMenuEN(item.menu);
              setDisclosureContentEN(item.content);
            } else if (item.language === "ES") {
              setIdES(item.id);
              setNameMenuES(item.menu);
              setDisclosureContentES(item.content);
            } else if (item.language === "PT") {
              setIdPT(item.id);
              setNameMenuPT(item.menu);
              setDisclosureContentPT(item.content);
            } else if (item.language === "FR") {
              setIdFR(item.id);
              setNameMenuFR(item.menu);
              setDisclosureContentFR(item.content);
            }
          });
        } else {
          resetState();
        }

        setDetailDisclosure(true);
      });
    }
  };

  const handleUpdate = (event, type) => {
    try {
      if (type === "EN") setDisclosureContentEN(event);
      if (type === "ES") setDisclosureContentES(event);
      if (type === "PT") setDisclosureContentPT(event);
      if (type === "FR") setDisclosureContentFR(event);
    } catch (e) {
      console.log(e);
    }
  };

  const handleDelete = (title) => {
    dispatch(deleteDisclosureAffiliate({ title })).then(() => setDetailDisclosure(false));
  };

  const renderButtonRight = () => (
    <button className="buttonRight" onClick={() => handleOpenDetail(null, "add")}>
      <i className="fa fa-plus" aria-hidden="true" />
      Add new Menu
    </button>
  );

  useEffect(() => {
    getData();
    ReactDOM.render(renderButtonRight(), document.getElementById("renderButtonDisclosure"));
    // eslint-disable-next-line
  }, [detailDisclosure]);

  return !detailDisclosure ? (
    <div className="bigBoxTable">
      <table>
        <tbody>
          <tr>
            <th>{t("MENU")}</th>
            <th>{t("ORDER")}</th>
            <th>{t("STATUS")}</th>
            <th style={{ textAlign: "right" }}>{t("OPTIONS")}</th>
          </tr>

          {allMenu.length > 0 &&
            allMenu.map((item, i) => (
              <tr key={i}>
                <td>{item.title}</td>
                <td>{item.order}</td>
                <td>
                  <span className={item?.active ? "active" : "inativo"}>
                    {item?.active ? t("ACTIVE") : t("INACTIVE")}
                  </span>
                </td>
                <td>
                  <button onClick={() => handleOpenDetail(item, "")}>
                    {t("BTN_VIEW")} <i className="fa fa-angle-right" aria-hidden="true"></i>
                  </button>
                </td>
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  ) : (
    <div className="contentDetailDisclosure">
      <div className="header">
        <div className="divLeft">
          <div className="wrapperName">
            <label>{t("TITLE")}</label>
            <input type="text" value={title} onChange={(e) => setTitle(e.target.value)} />
          </div>

          <div className="wrapperName">
            <label>{t("ORDER")}</label>
            <input type="number" value={order} onChange={(e) => setOrder(e.target.value)} className="inputOrder" />
          </div>

          <div className="wrapperCheckbox">
            <label>{t("STATUS")}</label>
            <input
              type="checkbox"
              checked={status}
              id="switch-shadow-all"
              className="switch switch--shadow"
              onChange={() => setStatus(!status)}
            />
            <label htmlFor="switch-shadow-all">
              <span>{status ? t("YES") : t("NO")}</span>
            </label>
          </div>

          {idEN && (
            <SCButtonAddInput name="remove" onClick={() => handleDelete(title)}>
              {t("DELETE")} <i className="fa fa-times-circle-o fa-lg"></i>
            </SCButtonAddInput>
          )}
        </div>

        <div className="wrapperButtons">
          <button onClick={() => setDetailDisclosure(false)}>{t("BACK")}</button>
          <button onClick={handleSaveDetail}>{t("SAVE")}</button>
        </div>
      </div>

      <div>
        <div className="wrapperNameMenu">
          <div className="wrapperName">
            <label>Menu name</label>
            <input type="text" value={nameMenuEN} onChange={(e) => setNameMenuEN(e.target.value)} />
          </div>
        </div>

        <div className="wrapperTitle">
          <FlagIcon size={35} code={"US"} />
          <h1 className="titleEditor">{t("BTN_ENGLISH")}</h1>
        </div>

        <JoditEditor
          ref={editorEN}
          config={config}
          onChange={() => {}}
          className="joditEditor"
          value={disclosureContentEN}
          onBlur={(e) => handleUpdate(e, "EN")}
        />

        <div className="wrapperNameMenu mt_30">
          <div className="wrapperName">
            <label>Menu name</label>
            <input type="text" value={nameMenuES} onChange={(e) => setNameMenuES(e.target.value)} />
          </div>
        </div>

        <div className="wrapperTitle">
          <FlagIcon size={35} code={"ES"} />
          <h1 className="titleEditor mt-20">{t("BTN_SPANISH")}</h1>
        </div>

        <JoditEditor
          ref={editorES}
          config={config}
          onChange={() => {}}
          className="joditEditor"
          value={disclosureContentES}
          onBlur={(e) => handleUpdate(e, "ES")}
        />

        <div className="wrapperNameMenu mt_30">
          <div className="wrapperName">
            <label>Menu name</label>
            <input type="text" value={nameMenuPT} onChange={(e) => setNameMenuPT(e.target.value)} />
          </div>
        </div>

        <div className="wrapperTitle">
          <FlagIcon size={35} code={"BR"} />
          <h1 className="titleEditor mt-20">{t("BTN_PORTUGUESE")}</h1>
        </div>

        <JoditEditor
          ref={editorPT}
          config={config}
          onChange={() => {}}
          className="joditEditor"
          value={disclosureContentPT}
          onBlur={(e) => handleUpdate(e, "PT")}
        />

        <div className="wrapperNameMenu mt_30">
          <div className="wrapperName">
            <label>Menu name</label>
            <input type="text" value={nameMenuFR} onChange={(e) => setNameMenuFR(e.target.value)} />
          </div>
        </div>

        <div className="wrapperTitle ">
          <FlagIcon size={35} code={"FR"} />
          <h1 className="titleEditor mt-20">{t("FRENCH")}</h1>
        </div>

        <JoditEditor
          ref={editorFR}
          config={config}
          onChange={() => {}}
          className="joditEditor"
          value={disclosureContentFR}
          onBlur={(e) => handleUpdate(e, "FR")}
        />
      </div>
    </div>
  );
}

export default Disclosure;
